import { apiResource } from "./setup";

export const logoWhite = () => apiResource({
  url: 'images/dashboard/logo-white.png'
})

export const logoColor = () => apiResource({
  url: 'images/dashboard/logo.png'
})

export const defaultImageURL = () => apiResource({
  url: 'images/dashboard/sin_imagen.png'
})

export const loadingURL = () => apiResource({ url: 'images/dashboard/preloading.svg' })

export const notFoundImage = () => apiResource({
  url: 'images/dashboard/not-found.png'
})